import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import {environment} from '../../environments/environment';
import { IUser } from '../interfaces/entity';

@Injectable({providedIn: 'root'})
export class ApplicationService
{
    private _authenticated = false;

    /**
     * Constructor
     */
    constructor(
        private httpClient: HttpClient,
    )
    {
    }

    getApplications(params: any, searchInfo?: any): Observable<any>{
        params.searchInfo = searchInfo;
        return this.httpClient.get(`${environment.baseUrl}/getApplicationList`, {params});
    }

    getSurveyList(params: any, searchInfo?: any): Observable<any>{
        params.searchInfo = searchInfo;
        return this.httpClient.get(`${environment.baseUrl}/getSurveyList`, {params});
    }

    getPayments(params: any, searchInfo?: any): Observable<any>{
        params.searchInfo = searchInfo;
        return this.httpClient.get(`${environment.baseUrl}/getPaymentList`, {params});
    }

    getUsers(params: any, searchInfo?: any): Observable<any>{
        params.searchInfo = searchInfo;
        return this.httpClient.get(`${environment.baseUrl}/getUserList`, {params});
    }
    editUser(userData: IUser): Observable<any>{

        return this.httpClient.post(`${environment.baseUrl}/auth/edit`, userData);
    }

    searchApplicationByName(applicationNo: string): Observable<any> {
        return this.httpClient.get<any>(`${environment.baseUrl}/searchApplicationByName/${applicationNo}`);
    }

    submitFeedback(payload: any) {
        return this.httpClient.post(`${environment.baseUrl}/survey/submitFeedback`, payload);
    }


}
